import React from 'react'
import { startOfDay, endOfDay, addDays } from 'date-fns'

import Information from '@SonarCX/pages/Dashboard/TasksTab/BodyWidgets/Information'
import ReminderWidget from '@SonarCX/components/molecules/ReminderWidget'
import ReminderRow from '../ReminderRow'

import useDashboardReminders from '../../hooks/useDashboardReminders'

import useStyles from './styles'

type UpcomingRemindersProps = {
  upcomingDays?: number
  skipDays?: number
  fullWidth?: boolean
}

const UpcomingReminders: React.FC<UpcomingRemindersProps> = ({
  upcomingDays,
  skipDays,
  fullWidth = false
}) => {
  const dateRangeEnd = upcomingDays
    ? endOfDay(addDays(new Date(), upcomingDays))
    : endOfDay(new Date())

  const dateRangeStart = skipDays
    ? startOfDay(addDays(new Date(), skipDays))
    : startOfDay(new Date())
  const { getKey } = useDashboardReminders({
    dateRangeStart,
    dateRangeEnd
  })

  const title = upcomingDays ? `Due next ${upcomingDays} days` : 'Due today'
  const noRemindersText = upcomingDays
    ? `No reminders due in the next ${upcomingDays} days`
    : 'No reminders due today'
  const infoText = upcomingDays
    ? `Upcoming reminders in ${upcomingDays} days`
    : `Today's reminders`
  const classes = useStyles({ fullWidth, notDueToday: !!upcomingDays })

  return (
    <ReminderWidget
      title={title}
      getKey={getKey}
      rowRenderer={ReminderRow}
      noRemindersText={noRemindersText}
      className={classes.title}
      infoComponent={<Information info={infoText} />}
      dateRangeEnd={dateRangeEnd.toISOString()}
      dateRangeStart={dateRangeStart.toISOString()}
    />
  )
}

export default UpcomingReminders
